import { Unifree, Text } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const CardTitle = styled(Text).attrs({
  variant: 'content-emphasis-04'
})<{ rightMargin?: boolean }>`
  color: ${({ theme }) => theme.colors._004099};
  margin-right: ${({ rightMargin }) => (rightMargin ? '8px' : '')};
`

export const Line = styled.hr`
  margin: 8px 0;
`

export const InformationalInput = styled(Unifree).attrs({
  required: true,
  informational: true,
  heightClass: 'small'
})``
